














import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { ListDisplayMode } from "@/data/constants";

// Types
import { IProductCategory } from "@/models/products";

@Component({
  components: {
    "catalogue-product-search": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/catalogueProductSearch.vue"
      )
  }
})
export default class CategoryProductsView extends Vue {
  // Props

  @Prop({ required: true })
  public categoryId!: IProductCategory["id"];

  @Prop({ required: true })
  public productTypes!: ProductTypes[];

  // Data

  public availableModes = [ListDisplayMode.TABLE, ListDisplayMode.GRID];

  // Computed

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }

  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public get title() {
    if (this.isOption) return this.$t("_.category_options");
    if (this.isAttribute) return this.$t("_.category_attributes");

    return this.$t("_.category_products");
  }

  public get manualFilters() {
    return { "filter[category_id]": this.categoryId };
  }
}
